import Vue from "vue";
import Router from "vue-router";
import store from "@/store";

Vue.use(Router);

const isBetaTester = (to, from, next) => {
  if (store) {
    if (store.getters["dealer/isBetaTester"]) {
      next();
      return;
    } else next("/");
  }
};

function loadView(view) {
  return () =>
    import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`);
}

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: loadView("Home"),
      alias: "/home"
    },
    {
      path: "/list-employees",
      name: "list employees",
      component: loadView("list-employees")
    },
    {
      path: "/app-personalise",
      name: "Personalise App",
      component: loadView("app-personalise")
    },
    {
      path: "/list-commissions",
      name: "List Commisisons",
      component: loadView("list-commissions")
    },
    {
      path: "/list-reports/:report",
      name: "Reports",
      component: loadView("list-reports")
    },
    {
      path: "/callback",
      name: "callback",
      component: loadView("Callback")
    },
    {
      path: "/login",
      name: "login",
      component: loadView("Login")
    },
    {
      path: "/personalise",
      name: "Personalise",
      component: loadView("personalise/personalise-menu")
    },
    {
      path: "/upload-logo",
      name: "Upload Logo",
      component: loadView("personalise/upload-logo")
    },
    {
      path: "/modify-custEmail/:section",
      name: "Modify Content",
      component: loadView("personalise/modify-custEmail")
    },
    {
      path: "/list-subdealers",
      name: "List Subdealers",
      component: loadView("list-subdealers")
    },
    {
      path: "/demo",
      name: "Demo",
      component: loadView("basic")
    },
    {
      path: "/partner-logins",
      name: "Partner Logins",
      component: loadView("partner-activity")
    },
    {
      path: "/partner-details",
      name: "Partner Details",
      component: loadView("partner-details")
    },
    {
      path: "/nampt/login",
      name: "NAMPT ProtoType",
      component: loadView("nampt-login")
    },
    {
      path: "/link/link-callLog",
      name: "Call Log",
      component: loadView("link/link-callLog"),
      meta: { title: "Vonex Link - Call Log" },
      beforeEnter: isBetaTester
    },
    {
      path: "/link/link-extensions",
      name: "Extensions",
      component: loadView("link/link-extensions"),
      props: true,
      meta: { title: "Vonex Link - Extensions" },
      beforeEnter: isBetaTester
    },
    {
      path: "/link/link-huntGroups",
      name: "Huntgroups",
      component: loadView("link/link-huntGroup"),
      meta: { title: "Vonex Link - Hunt Group" },
      beforeEnter: isBetaTester
    },
    {
      path: "/link/domains",
      name: "Domains",
      component: loadView("link/link-listDomains"),
      meta: { title: "Vonex Link - Domains" },
      beforeEnter: isBetaTester
    },
    {
      path: "/link/link-actions/:domain",
      name: "Numbers",
      component: loadView("link/link-actions"),
      props: true,
      meta: { title: "Vonex Link - Main Menu" },
      beforeEnter: isBetaTester
    },
    {
      path: "/link/link-registrations",
      name: "Registrations",
      component: loadView("link/link-registrations"),
      meta: { title: "Vonex Link - Registrations" },
      beforeEnter: isBetaTester
    },
    {
      path: "/link/link-serviceFlags",
      name: "Service Flags",
      component: loadView("link/link-serviceFlags"),
      meta: { title: "Vonex Link - Service Flags" },
      beforeEnter: isBetaTester
    },
    {
      path: "/link/link-buttons",
      name: "Buttons",
      component: loadView("link/link-buttons"),
      meta: { title: "Vonex Link - Buttons" },
      beforeEnter: isBetaTester
    },
    {
      path: "/link/link-routing",
      name: "Routing",
      component: loadView("link/link-routing"),
      meta: { title: "Vonex Link - Routing" },
      beforeEnter: isBetaTester
    }
  ]
});
